import Phaser from 'phaser';
import { nameText } from '../../content/names';
import type { BlockList } from '../../meta/online/schema';
import { blockedPlayers, unblockPlayer } from '../online';
import { bevelButton, clearScene, navyPanel } from '../ui/chrome';
import { label, UI } from '../ui/text';
import { wipeTo } from './WipeScene';

/**
 * Settings > ONLINE > BLOCKED (lm-wxl.17; App Store guideline 1.2): the players this player
 * blocked, whose community lawns no longer show for them, each with UNBLOCK.
 */
export class BlockedScene extends Phaser.Scene {
  private list: BlockList | null = null;
  private loading = true;

  constructor() {
    super('Blocked');
  }

  init(): void {
    this.list = null;
    this.loading = true;
  }

  create(): void {
    this.cameras.main.setBackgroundColor('#15102f');
    this.draw();
    void this.fetchList();
  }

  private async fetchList(): Promise<void> {
    this.list = await blockedPlayers();
    this.loading = false;
    this.redraw();
  }

  private readonly redraw = (): void => {
    if (!this.scene.isActive()) return;
    clearScene(this);
    this.draw();
  };

  private draw(): void {
    const { width, height } = this.scale.gameSize;
    const g = this.add.graphics();
    g.fillStyle(UI.panel).fillRect(0, 0, width, 22);
    g.fillStyle(UI.rule).fillRect(0, 22, width, 1);
    label(this, 6, 4, 'BLOCKED', 2);
    const backY = height - 30;
    bevelButton(this, 6, backY, width - 12, 24, 'BACK', () => wipeTo(this, 'Online'));
    const list = this.list;
    if (!list || list.blocked.length === 0) {
      const text = this.loading
        ? 'Loading...'
        : !list
          ? "Can't reach the server right now."
          : "Nobody blocked. On a community lawn's card, BLOCK MAKER hides that player's lawns.";
      label(this, width / 2, 40, text, 1, UI.dim)
        .setOrigin(0.5, 0)
        .setMaxWidth(width - 16)
        .setCenterAlign();
      return;
    }
    let y = 30;
    for (const b of list.blocked) {
      if (y + 20 > backY - 6) break;
      navyPanel(g, 4, y, width - 8, 20);
      label(this, 10, y + 6, nameText(b.name), 1, UI.text);
      bevelButton(this, width - 66, y + 3, 58, 14, 'UNBLOCK', () => void this.unblock(b.player));
      y += 22;
    }
  }

  private async unblock(player: string): Promise<void> {
    if (!(await unblockPlayer(player))) return;
    this.list = this.list && {
      blocked: this.list.blocked.filter((b) => b.player !== player),
    };
    this.redraw();
  }
}
